import * as React from 'react'
import { useState, useContext } from 'react'
import Select from 'react-select'
import CommonContext from '../../CommonContext'
import RemoveFieldsButton from '../../shared/RemoveFieldsButton'

type DuplicateFormFieldsRowProps = {
  jobPlanning: {
    id: string
    jobnumber_id: string
    jobnumber: { id: string }
    quantity: string
    comment: string
    actually_completed: string
    description: string
    finished_date: string
    placement: string
    user_id?: number
    task_id?: string
  }
  tasks: Array<{ id: string; number: string; description: string }>
  removeRow: () => void
  fieldName: (field: string) => string
  showRemoveFieldsButton?: boolean
}
export default function DuplicateFormFieldsRow({ jobPlanning, tasks, removeRow, fieldName, showRemoveFieldsButton }: DuplicateFormFieldsRowProps) {
  const dictionaries = useContext(CommonContext)
  const { availableUsers } = dictionaries
  const { jobnumber } = jobPlanning
  const users = availableUsers.map(u => {
    return { label: `${u.username} - ${u.name}`, value: u.id }
  })
  const [userId, setUserId] = useState(jobPlanning.user_id)
  const [taskId, setTaskId] = useState(jobPlanning.task_id)

  return (
    <tr>
      <td>
        <input type="hidden" name={fieldName('jobnumber_id')} value={jobnumber.id} />
        <select
          name={fieldName('task_id')}
          className="form-control resources-time-task"
          value={taskId}
          onChange={e => setTaskId(e.target.value)}
          required
        >
          {tasks.map(task => {
            return (
              <option key={task.id} value={task.id}>
                {`${task.number} - ${task.description}`}
              </option>
            )
          })}
        </select>
      </td>
      <td>
        <input
          required
          type="date"
          className="form-control col-xs-12"
          defaultValue={jobPlanning.finished_date}
          name={fieldName('finished_date')}
        />
      </td>
      <td>
        <Select
          placeholder="Vælg eller skriv..."
          menuPosition="fixed"
          required
          options={users}
          value={users.find(u => u.value === userId)}
          onChange={option => {
            setUserId(option.value)
          }}
        />
        <input type="hidden" name={`${fieldName('user_ids][')}`} value={userId} />
      </td>
      <td>
        <input
          required
          type="number"
          step="0.25"
          placeholder="0.0"
          max="24"
          min="0"
          className="form-control col-xs-12"
          defaultValue={jobPlanning.quantity}
          name={fieldName('quantity')}
        />
      </td>
      <td>
        <input type="text" className="form-control col-xs-12" defaultValue={jobPlanning.comment} name={fieldName('comment')} />
      </td>
      <td>
        <input
          type="text"
          maxLength={30}
          className="form-control col-xs-12"
          defaultValue={jobPlanning.placement}
          name={fieldName('placement')}
        />
      </td>
      <td className="text-center">{showRemoveFieldsButton && <RemoveFieldsButton handleRemove={removeRow} />}</td>
    </tr>
  )
}

